module.exports = "https://cdn.littlereply.com/tt/resource/earn_coins_post_placeholder.b32533efb017d3b7cb77920f5e440308.png";